import React, {useEffect} from 'react';
import {List} from "@material-ui/core";
import ListingRow from "./ListingRow";

function TemplateListing(props) {

  const handleClick = (data) => {
    props.handleOpenNewTemplate(data); 
    
  };

  return (
    <List>
      {props.templates.data && props.templates.data.map((m,i) => {
        return (
          <ListingRow
            data={m}
            leftPrimary={`Template ${i+1}`}
            middlePrimary={m.type}
            middleSecondary={m.name}
            buttonLabel={'Send Email'}
            buttonAction={()=>handleClick(m)}
            key={`${"m.name"}-listing-${Math.random()}`}
          />
        )
      })}
    </List>
  );
}

export default TemplateListing;
